import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class PopularService {
  private apiUrl = environment.apiUrl+'/popular';

  constructor(private http: HttpClient) { }
  getData(): Observable<any> {
    return this.http.get('/api/popular');
  }
}
